import { Link } from "react-router-dom";

const footerLinks = {
  Product: [
    { name: "Overview", path: "/product" },
    { name: "Use Cases", path: "/use-cases" },
    { name: "x402 Agent Payments", path: "/x402" },
    { name: "Contact Sales", path: "/contact" },
    { name: "Documentation", path: "/docs" },
  ],
  Company: [
    { name: "About", path: "/about" },
    { name: "Contact", path: "/contact" },
    { name: "Investors", path: "/investors" },
  ],
  Resources: [
    { name: "Research", path: "/whitepapers" },
    { name: "Governance", path: "/governance" },
    { name: "API Reference", path: "/docs" },
    { name: "SDK Guide", path: "/docs" },
  ],
};

const socialLinks = [];

export const Footer = () => {
  return (
    <footer className="bg-swarm-darker border-t border-swarm-border" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-16">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_sentinel-hub-28/artifacts/jsghs2ap_swarmcitadel-horizontal-primary-dark-bg-2172x724.png"
                alt="SwarmCitadel"
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              The governance and operations layer for AI agent swarms.
            </p>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-white font-semibold mb-4">{category}</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-slate-400 hover:text-swarm-cyan text-sm transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-swarm-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {new Date().getFullYear()} Swarm Citadel Inc. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-slate-500 hover:text-slate-300 text-sm transition-colors" data-magnetic>
              Privacy Policy
            </a>
            <a href="#" className="text-slate-500 hover:text-slate-300 text-sm transition-colors" data-magnetic>
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
